// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import BackToTop from 'vue-backtotop'
import store from './store'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(BackToTop);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/animate.css'
import './assets/css/font-awesome.min.css'
import './assets/css/custom-bootstrap-margin-padding.css'
import './assets/css/frontend.css'
import './assets/css/responsive-frontend.css'


/* eslint-disable no-new */
new Vue({
	created () {
	  AOS.init({
	  	once: true
	  })
	},
  	el: '#wrapper',
  	router,
  	store,
  	components: { App },
  	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js